import SwitchComponent from './switch.component'

const SwitchModule = angular.module('cdbl.switch', [

])
  .component('cdblSwitch', SwitchComponent)
  .name

export default SwitchModule
